import React, { Component } from 'react'
import { connect } from 'react-redux'
import { signIn, signInGuest, signInGuest2, trackBot } from '../../store/actions/authActions'
import { Redirect, NavLink } from 'react-router-dom'
import AdSummary from "../ads/AdSummary";

class SignIn extends Component {
  state = {
    email: '',
    password: '',
    lat: 0,
    lng: 0,
    httpResponse:'',
    currentAddress:'',
    currentState:'',
    currentZip:'',
    currentCity:''
  }

componentDidMount(props){
  var options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  };

  const success = position => {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    //console.log(latitude, longitude);
    if(this.state.mount){
      this.setState({
        lat: latitude,
        lng: longitude
      });  
    }
    this.getAddress([this.state.lat, this.state.lng]);
  };

  const error = () => {
    alert("Unable to retrieve your location");
  };

  navigator.geolocation.getCurrentPosition(success, error, options);

  this.setState({mount:true, adNumber: Math.floor(Math.random() * 3)});
}

componentDidUpdate(){    
  if(this.state.httpResponse !== '' & this.state.currentAddress===''){
    //console.log(this.state.httpResponse['resourceSets'][0]['resources'][0]['address'])

    var currentCity = ""
    if(this.state.httpResponse['resourceSets'][0]['resources'][0]['address']['adminDistrict2']==="Richmond City"){
      currentCity="Richmond"
    }
    else{
      currentCity=this.state.httpResponse['resourceSets'][0]['resources'][0]['address']['adminDistrict2'];
    }

    this.setState({
      currentAddress:this.state.httpResponse['resourceSets'][0]['resources'][0]['address']['addressLine'],
      currentState:this.state.httpResponse['resourceSets'][0]['resources'][0]['address']['adminDistrict'],
      currentZip:this.state.httpResponse['resourceSets'][0]['resources'][0]['address']['postalCode'],
      currentCity:currentCity
    })
  }
}

getAddress = (location) => {
    var point = location.toString();
    //console.log(point);
    const Http = new XMLHttpRequest();
    if(point !== "0,0"){
      var url = 'https://dev.virtualearth.net/REST/v1/Locations/'+location[0]+','+location[1]+'?&key=AkkmVqZTTAl0pdIReyon_6fwQ9WkzPuTxhYYqAAjV08oE2_jX_OqCj1Dbytnlh_O';

      Http.open("GET", url);
      Http.send();
      const that = this;

      Http.onreadystatechange=function(){
        if(this.readyState === 4 && this.status === 200 && that.state.httpResponse !== Http.responseText){
          var parsedJSON = JSON.parse(Http.responseText);
          that.setState({httpResponse:parsedJSON})
        }
      }
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({bot:false});
    this.props.signIn(this.state)
  }
  handleGuest = (bot) => {
    
    this.setState({guest:true});
    if(this.state.currentAddress === ""){
      let distanceList = false;
      this.props.signInGuest(distanceList, (userId)=>{
      //console.log('user ID');
      //console.log(userId);
      if(bot === "bot"){
        this.setState({bot:true});
      }
      else{
        this.setState({bot:false});
      }
      })  
    }
    else{
      var currentCity = this.state.currentCity;
      var currentAddress = this.state.currentAddress;
      var currentZip = this.state.currentZip;
      var currentState = this.state.currentState;
      var location = [this.state.lat,this.state.lng];
      this.props.signInGuest2(currentCity, currentAddress, currentZip, currentState, location, (userId)=>{
      //console.log('user ID');
      //console.log(userId);
      this.setState({bot:false});
    })
    }
  }
  
  render() {
    const { authError, auth } = this.props;
    //if (auth.uid === 'X9cY4fGY1qXqZ0iW1cic26GlTkK2') return <Redirect to='/about' />
    var botInfo = {};
    if (this.state.bot){
      return <Redirect to='/blog' />  
    } 
    
    const { userAgent } = window.navigator;
    
    if (auth.uid && !userAgent.includes("Googlebot")) return <Redirect to='/' />
      
    // comment this out to have googlebot sign in as a guest
    if(userAgent.includes("Googlebot"))  {
      botInfo = {botType:"Googlebot", userAgent:userAgent};
      this.props.trackBot(botInfo);
      return <Redirect to='/blog' />
    }

    if(userAgent.includes("Mediapartners-Google"))  {
      botInfo = {botType:"Adsense", userAgent:userAgent};
      this.props.trackBot(botInfo);
      return <Redirect to='/blog' />
    }
      
    if(userAgent.includes("Googlebot") && !this.state.guest){
      this.setState({guest:true});
      //console.log('sign in bot')
      this.handleGuest("bot");
      // this.props.signIn({email:'testbotuser@testuser.com', password:'googlebot'})
    }


    return (
      <div className="signInContainer" style={{"paddingBottom":"10px"}}>
        <form className="formContainer" onSubmit={this.handleSubmit} style={{"borderRadius":"20px", "padding":"10px"}}>
          <h5 className="grey-text text-darken-3" style={{"textAlign":"center"}} >Sign In</h5>
          <div className="input-field">
            <label htmlFor="email">Email</label>
            <input type="email" id='email' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label htmlFor="password">Password</label>
            <input type="password" id='password' onChange={this.handleChange} />
          </div>
          <div className="input-field" style={{"display":"flex", "justifyContent":"space-around"}} >
            <button className="btn pink lighten-1 z-depth-0" onClick={this.handleSubmit}>Login</button>
            <NavLink to='/signup'><button className="btn pink lighten-1 z-depth-0">Sign Up</button></NavLink>
          </div>
          { 
            <div className="input-field" style={{"display":"flex", "justifyContent":"center"}} >
              <button className="btn pink lighten-1 z-depth-0" onClick={this.handleGuest}>Continue as Guest</button>
            </div>  
          }
          { !this.state.guest &&
            <div className="input-field" style={{"display":"flex", "justifyContent":"center"}} >
              <div className="center red-text">
                { authError ? <p>{authError}</p> : null }
              </div>
            </div>
          }
        </form>
      
      {/*<br/>
      <br/>
      {this.state.adNumber !== undefined && <AdSummary adInformation = {this.state.adNumber}/>}*/}
      
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return{
    authError: state.auth.authError,
    auth: state.firebase.auth
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (creds) => dispatch(signIn(creds)),
    signInGuest: (distanceList, callback) => dispatch(signInGuest(distanceList, callback)),
    signInGuest2: (currentCity, currentAddress, currentZip, currentState, location, callback) => dispatch(signInGuest2(currentCity, currentAddress, currentZip, currentState, location, callback)),
    trackBot: (botInfo) => dispatch(trackBot(botInfo))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn)